import { useRef } from "react";

export type Task = (...args: any) => Promise<any>
export interface TaskQueue {
    push:(task:Task) => void
}

export default () : TaskQueue => {
    const queue= useRef<Promise<any>[]>([]);

    const push = (task: Task) => {
        const fn = async () => {
            await task();
            queue.current.pop();
        };
 
        if (queue.current.length == 0) {
            queue.current.push(fn());
        }
        else {
            queue.current.push(queue.current.at(-1)!.then(fn));
        }


    }

    return {
        push
    }

};